import { FormattedMessage } from 'react-intl';

import { TCreditAgreementRequirement } from '../../fundingRequirements.types';
import { RequirementItem } from '../RequirementItem/RequirementItem';

export const CreditAgreement = ({ status }: TCreditAgreementRequirement) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements_v2.type.credit_agreement"
                    defaultMessage="Sign your credit agreement"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements_v2.time.2_min"
                    defaultMessage="~ 2 Min."
                />
            }
            status={status}
        />
    );
};
